import React from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import Tooltip from './Tooltip';
import Grid from './Grid';

function BoxComponent(props: IBox) {
    return (
        <BoxTag sub={props.sub}>
            <div>
                <BoxLabelTag required={props.required}>
                    {props.label.split('\\n').map((one, index) => (
                        <span key={index}>
                            {one}
                            <br />
                        </span>
                    ))}
                </BoxLabelTag>
                {/* {props.toolTip && (
                    <Tooltip title={props?.toolTipTitle}>
                        <Grid color="#f2f4f7" left={5} right={5}>
                            ?
                        </Grid>
                    </Tooltip>
                )} */}
            </div>

            <div>{props.children}</div>
        </BoxTag>
    );
}
export default React.memo(BoxComponent);

/**
 * Box interface
 */
export interface IBox {
    /**
     * 자식 Type
     */
    children?: React.ReactNode;

    /**
     * 라벨
     */
    label: string;
    /**
     * 필수여부 (스타일)
     */
    required?: boolean;
    /**
     * 하위 박스 여부 (배경색이 달라짐)
     */
    sub?: boolean;

    /**
     * 툴팁 사용여부
     */
    toolTip?: boolean;

    /**
     * 툴팁 타이틀
     */
    toolTipTitle?: string;
}

export interface IBoxTag extends Pick<IBox, 'sub'> {}
export interface IBoxLabelTag extends Pick<IBox, 'required'> {}

export const BoxLabelTag = styled.label<IBoxLabelTag>`
    display: inline-block;
    line-height: 1rem;
    font-weight: 600;
    position: relative;

    // 장식 / 접두사
    ${({ required, theme }) =>
        _.isBoolean(required) &&
        `
    ::after {
      content: '';
      display: inline-block;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: ${theme.color.point};
      vertical-align: top;
      position: absolute;
      top: 0;
      right: -7px;
    }

    }`}
`;

export const BoxTag = styled.div<IBoxTag>`
    display: flex;

    /* 자식이 자기를 넘으면 가려버린다 */
    overflow: hidden;

    & > div {
        &:first-child {
            background-color: ${(props) => props.theme.color.boxCategory};
            width: 192px;
            padding: 20px;
            font-size: 14px;
        }
        &:last-child {
            width: calc(100% - 192px);
            padding: 10px 10px;
        }
    }
    border-top: 1px solid ${({ theme }) => theme.color.borderDefault};
    border-left: 1px solid ${({ theme }) => theme.color.borderDefault};
    border-right: 1px solid ${({ theme }) => theme.color.borderDefault};
    border-bottom: 1px solid ${({ theme }) => theme.color.borderDefault};
    /* padding: 10px 0px; */
    &:last-child {
        border-bottom: 1px solid ${({ theme }) => theme.color.borderDefault};
    }
`;
